import axios from 'axios';
import { buildRevJetBanner, buildRevJetBannerMock } from './revjet';
import { getQueryParams, getApiUrl } from './requestUrlHelpers';
import {
  getUrlParams,
  getMockPlaData,
  isBrandFpn,
  haveProductsChanged,
  triggerNewRelicTimeLog
} from './helpers';
import { newRelicConstants } from '../constants';

export const shouldMakeApiRequest = ({ lastRequestScenario, experienceContext, pageContext, customRenderId }) => {
  if (isBrandFpn({ experienceContext, pageContext })) {
    return false;
  }

  const currentUrl = window.location.pathname + window.location.search;
  if (lastRequestScenario.url !== currentUrl) {
    if (pageContext?.isCategory || pageContext?.isPip || pageContext?.isStorePage) {
      return true;
    }

    if (haveProductsChanged({ lastRequestScenario, pageContext })) {
      return true;
    }
  }
  // we know this is from educational layout
  // so return true
  if (customRenderId) return true;
  return false;
};

export const makeApiRequest = (requestConfig) => {
  const params = getUrlParams(window.location.href);

  if (params.mockSponsoredBannerId) {
    requestConfig.setHasData(true);
    buildRevJetBannerMock(requestConfig);
  } else if (params.mockPlaSku) {
    requestConfig.setAdProducts(getMockPlaData(params.mockPlaSku));
  } else {
    const queryParams = getQueryParams(requestConfig);
    const apiUrl = getApiUrl(queryParams);

    axios.get(apiUrl).then((response) => {
      const { data } = response;
      if (data) {
        if (requestConfig.carouselType) {
          requestConfig.setAdProducts(data.products);
          if (requestConfig.setPageId) {
            requestConfig.setPageId(data.pageId);
          }
        } else {
          requestConfig.setHasData(true);
          if (requestConfig.startTime !== undefined) {
            triggerNewRelicTimeLog(newRelicConstants.STANDARD_BANNER_API_RESPONSE,
              requestConfig.startTime,
              Date.now());
          }
          buildRevJetBanner({ data, requestConfig });
        }
      }
    }).catch((error) => {
      // eslint-disable-next-line no-console
      console.log('ERROR: Could not make api request', error);
    });
  }
};
